import React from 'react';
import {usePhaseState} from '../phase-context';

function HideIf(props) {
  const {phases} = usePhaseState();
  const context = props.context || 'default';
  if (!(context in phases && 'phase' in phases[context])) return null;
  return [].concat(props.phase).includes(phases[context].phase) ? null : props.children;
}

export default HideIf;
